import { PerformanceReviewDimensionLevel } from '../types/v2';

// These are display labels only. Stored review levels remain unchanged so
// existing student and teacher reviews keep their original meaning.
export const performanceReviewLevelLabels: Record<PerformanceReviewDimensionLevel, string> = {
  needs_support: 'Non-Proficient',
  developing: 'Developing',
  meets_expectations: 'Proficient',
  extends_expectations: 'Mastery',
  not_observed: 'Not Observed',
};
